import './AppLoader.scss';
import spinner from '../../assets/images/spinner.svg';
import { useEffect } from 'react';

const AppLoader = ({ showText = true }) => {
  useEffect(() => {
    // Disable scrolling when the loader is visible
    const scrollY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollY}px`;
    document.body.style.overflow = 'hidden';
    document.body.dataset.scrollY = scrollY.toString();

    return () => {
      const scrollY = document.body.dataset.scrollY || '0';
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.overflow = '';
      window.scrollTo(0, parseInt(scrollY));
    };
  }, []);


  return (
    <div className="c-app-loader">
      <div className="c-loader">
        <img src={spinner} alt="loading" className="loader__spinner-img" />
        {showText && <h1>Loading ...</h1>}
      </div>
    </div>
  );
}

export default AppLoader;
